import React from 'react'
import { format } from 'date-fns'

import { Typography, Button, Avatar } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'
import { Transcription } from 'models/Transcription/Transcription.type'

import { cellphoneMask } from 'utils'
import { formatCpf } from 'utils/textTransformations'

import { ReactComponent as IconMail } from 'static/svg/icon_mail_24x24.svg'
import { ReactComponent as IconPhone } from 'static/svg/icon_telefone_24x24.svg'
import { ReactComponent as AssignmentIcon } from 'static/svg/assignment-icon.svg'

import * as S from './styles'

interface PatientDetailProfessionalModalProps {
  name: string
  phone: string
  email: string
  cpf?: string
  onClose: () => void
  transcription?: Transcription | null
}

export function PatientDetailProfessionalModal({
  onClose,
  email,
  name,
  phone,
  cpf,
  transcription,
}: PatientDetailProfessionalModalProps): JSX.Element {

  // TODO (Preenchimento automático): Descomentar a constante e validação quando o preenchimento automático for implementado.
  // const shouldShowTranscriptionInfo = 
  //   transcription && 
  //   transcription.enabled !== null &&
  //   transcription.acceptanceDate !== null
  const shouldShowTranscriptionInfo = false // Mock desabilitado para esconder o TranscriptionInfo do profissional por enquanto

  return (
    <ModalGeneric
      modalTitle=''
      onCloseModal={onClose}
    >
      <S.Container>
        <Avatar
          alt='paciente'
          src='/static/avatar.png'
          size='large'
        />
        <S.Content>
          <span>Paciente</span>
          <Typography
            weight='bold'
            variant='header4'
            inlineStyles={{
              textAlign: 'center'
            }}
          >
            {name}
          </Typography>
          <S.UserList>

            {!!cpf && (
              <S.UserItem>
                <Typography
                  variant='content2'
                >
                  CPF: {formatCpf(cpf)}
                </Typography>
              </S.UserItem>
            )}

            <S.UserItem>
              <IconPhone />
              <Typography
                variant='content2'
              >
                {cellphoneMask(phone)}
              </Typography>
            </S.UserItem>

            <S.UserItem>
              <IconMail />
              <Typography
                variant='content2'
              >
                {email}
              </Typography>
            </S.UserItem>

          </S.UserList>


          {shouldShowTranscriptionInfo && (
            <>
              <S.Divider />
              <TranscriptionInfo
                transcription={transcription}
              />
            </>
          )}

          <Button
            variant='contained'
            onClick={onClose}
            inlineStyles={{
              width: '100%',
              marginTop: '30px',
            }}
          >
            FECHAR
          </Button>
        </S.Content>
      </S.Container>
    </ModalGeneric>
  )
}

const TranscriptionInfo = ({ transcription }: { transcription: Transcription }) => {

  const info = transcription.enabled
    ? {
      message: <Typography color='success' weight='bold' variant='content2'>Transcrição da consulta permitida</Typography>,
      icon: <AssignmentIcon fill='#4AC326' />,
    }
    : {
      message: (
        <Typography color='danger' weight='bold' variant='content2'>
          Transcrição da consulta não permitida
        </Typography>
      ),
      icon: <AssignmentIcon fill='#FF2929' />,
    }

  return (
    <S.TranscriptionInfoContainer>
      <S.TranscriptionInfoIcon>
        {info.icon}
        {info.message}
      </S.TranscriptionInfoIcon>
      <S.TranscriptionInfoDate>
        <Typography variant='content2'>Em {format(transcription.acceptanceDate, 'dd/MM/yy\', às\' HH:mm')}</Typography>
      </S.TranscriptionInfoDate>
    </S.TranscriptionInfoContainer>
  )
}